import { useState } from 'react';
import { FormRiderModel } from '../../../models/formRider';
import axios from '../../../lib/axios';
import { FORM_RIDER_CONFIRM } from '../../../lib/endpoints/rider';

interface Props {
  selectData: FormRiderModel;
  onFetchData: Function;
  onClose: VoidFunction;
}

const useFormRiderRegister = ({ selectData, onFetchData, onClose }: Props) => {
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [loadingConfirm, setLoadingConfirm] = useState<boolean>(false);

  const handleOpenConfirmForm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirmForm = () => {
    setOpenConfirm(false);
  };

  const handleConfirmFormRiderRegister = async () => {
    try {
      setLoadingConfirm(true);
      await axios.post(FORM_RIDER_CONFIRM + selectData?.id);
      await onClose();
      await onFetchData();
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingConfirm(false);
      setOpenConfirm(false);
    }
  };

  return {
    handleCloseConfirmForm,
    handleOpenConfirmForm,
    openConfirm,
    loadingConfirm,
    handleConfirmFormRiderRegister,
  };
};
export default useFormRiderRegister;
